export default "/_next/static/a503cec85c645083ff3dbc74d272dcd3.png";